import { render, staticRenderFns } from "./ModalNotificationSuccess.vue?vue&type=template&id=004f21c5&"
import script from "./ModalNotificationSuccess.vue?vue&type=script&lang=ts&"
export * from "./ModalNotificationSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports